var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockwiseArrow = function SvgClockwiseArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.744 4.094C2.977 2.177 5.194.25 9 .25c2.81 0 5.497 1.938 7.387 3.702.724.675 1.356 1.35 1.863 1.928V1a.75.75 0 0 1 1.5 0v7a.75.75 0 0 1-.75.75h-7a.75.75 0 0 1 0-1.5h5.45a25.992 25.992 0 0 0-2.087-2.202C13.503 3.312 11.19 1.75 9 1.75c-3.193 0-4.977 1.573-5.994 3.156a9.166 9.166 0 0 0-1.262 3.192l-.001.008a.75.75 0 0 1-1.485-.212L1 8l-.742-.107V7.89l.001-.007.003-.02.012-.072A10.036 10.036 0 0 1 .55 6.684c.217-.701.586-1.643 1.195-2.59Z",
    fill: "#050400"
  })));
};
export default SvgClockwiseArrow;